import React from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, toAbsoluteUrl, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import {useAuth} from '../../../../../app/modules/auth'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  lockIcon?: string
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  lockIcon,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {setShowBillingModal} = useAuth()
  const {app} = config
  return (
    <div
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      {...(!lockIcon ? {'data-kt-menu-trigger': 'click'} : {})}
      onClick={
        lockIcon
          ? () => {
              setShowBillingModal(true)
            }
          : undefined
      }
    >
      <span className='menu-link'>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        {lockIcon && (
          <img
            src={toAbsoluteUrl(lockIcon)}
            alt='lock icon'
            width={15}
            className={`me-2`}
            height={15}
          />
        )}
        <span className='menu-title'>{title}</span>
        {!lockIcon && <span className='menu-arrow'></span>}
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isActive})}>
        {children}
      </div>
    </div>
  )
}

export {SidebarMenuItemWithSub}
